import { useDashboardCalculations } from '../hooks/useDashboardCalculations'

// THIS FILE DOESN'T ACTUALLY RENDER - I ADDED IT BECAUSE IT WAS A COMMENT BEFORE AND WE DIDNT REALLY
// NEED IT, BUT I WANTED TO KEEP IT IN CASE IT WAS USEFUL
export const CalculationDebug = () => {
  const {
    netIncomeTodayCalculated,
    netIncomeInRetirementCalculated,
    gapCalculated,
    retirementDate,
    todaysDate,
    daysTillRetirement,
    plannedRetirementMonth,
    plannedRetirementDay,
    plannedRetirementYear,
    personalDetailsCurrentAge,
    personalDetailsPlannedRetirementAge,
    eligibilityScenariosModeledRetirementAgeSub,
    eligibilityScenarios62Checker,
    payStubDetailsFEGLIOptionBMultiples,
  } = useDashboardCalculations()
  return (
    <SoftBox>
      <Grid item xs={12}>
        <SoftBox my={3} textAlign="left">
          <p> Net Incomt in Retirement Calc</p>
          <p>Gross income - FEHB - Basic Life - Income Taxes</p>
          <p>Gross income = Pension + FERS Supplement + Social Security</p>
          <p>Pension =</p>
          <p>FERS Supplement =</p>
          <p>Social Security =</p>
          <p>FEHB = {intakeState.healthInsurancePremium}</p>
          <p>
            {` Basic Life = if (age to begin collecting Social Security >= 65) then
            0 otherwise`}
          </p>
          <p>age to begin collecting = max of 62 or 62 checker </p>
          <p>
            62 check = if ( modeled retirement age is between 60.5 and 62) then
            62 otherwise difference between DOB and modeled retirement age
          </p>
          <p>ModeledRetirementAge = Max of the 3 Computation Dates</p>
          <p>
            DOB: {intakeState.dateOfBirth} - Service Comp Date:{' '}
            {intakeState.dateOfHire}
          </p>
          <p>Income Taxes =</p>
          <p>&nbsp;</p>
          <p>personalDetailsName = {personalDetailsName}</p>
          <p>personalDetailsAgency = {personalDetailsAgency}</p>
          <p>personalDetailsDOB = {personalDetailsDOB}</p>
          <p>personalDetailsCYS = {personalDetailsCYS}</p>
          <p>personalDetailsSCD = {personalDetailsSCD}</p>
          <p>personalDetailsCurrentAge = {personalDetailsCurrentAge}</p>
          <p>
            personalDetailsPlannedRetirementAge ={' '}
            {personalDetailsPlannedRetirementAge}
          </p>
          <p>
            personalDetailsPlannedRetirementDate ={' '}
            {personalDetailsPlannedRetirementDate}
          </p>
          <p>&nbsp;</p>
          <p>
            eligibilityScenariosScenario1Age ={' '}
            {eligibilityScenariosScenario1Age}
          </p>
          <p>
            eligibilityScenariosScenario1YearsofService ={' '}
            {eligibilityScenariosScenario1YearsofService}
          </p>
          <p>
            eligibilityScenariosScenario1Date ={' '}
            {eligibilityScenariosScenario1Date}
          </p>
          <p>
            eligibilityScenariosScenario2Age ={' '}
            {eligibilityScenariosScenario2Age}
          </p>
          <p>
            eligibilityScenariosScenario2YearsofService ={' '}
            {eligibilityScenariosScenario2YearsofService}
          </p>
          <p>
            eligibilityScenariosScenario2Date ={' '}
            {eligibilityScenariosScenario2Date}
          </p>
          <p>
            eligibilityScenariosScenario3Age ={' '}
            {eligibilityScenariosScenario3Age}
          </p>
          <p>
            eligibilityScenariosScenario3YearsofService ={' '}
            {eligibilityScenariosScenario3YearsofService}
          </p>
          <p>
            eligibilityScenariosScenario3Date ={' '}
            {eligibilityScenariosScenario3Date}
          </p>
          <p>
            eligibilityScenariosFirstFullyEligibleDate ={' '}
            {eligibilityScenariosFirstFullyEligibleDate}
          </p>
          <p>
            eligibilityScenariosFirstFullyEligibleAge ={' '}
            {eligibilityScenariosFirstFullyEligibleAge}
          </p>
          <p>
            eligibilityScenariosModeledRetirementDate ={' '}
            {eligibilityScenariosModeledRetirementDate}
          </p>
          <p>
            eligibilityScenariosModeledRetirementAgeSub ={' '}
            {eligibilityScenariosModeledRetirementAgeSub}
          </p>
          <p>eligibilityScenarios62Checker = {eligibilityScenarios62Checker}</p>
          <p>
            eligibilityScenarios62CheckerUsed ={' '}
            {eligibilityScenarios62CheckerUsed}
          </p>
          <p>
            eligibilityScenariosAdjRetirementDate ={' '}
            {eligibilityScenariosAdjRetirementDate}
          </p>
          <p>
            eligibilityScenariosModeledCYSinRetirement ={' '}
            {eligibilityScenariosModeledCYSinRetirement}
          </p>
          <p>&nbsp;</p>
          <p>payStubDetailsAnnualSalary = {payStubDetailsAnnualSalary}</p>
          <p>payStubDetailsHighThree = {payStubDetailsHighThree}</p>
          <p>payStubDetailsFICA = {payStubDetailsFICA}</p>
          <p>
            payStubDetailsTSPContributionPercentage ={' '}
            {payStubDetailsTSPContributionPercentage}
          </p>
          <p>
            payStubDetailsTSPContributionAmount ={' '}
            {payStubDetailsTSPContributionAmount}
          </p>
          <p>payStubDetailsIncomeTaxes = {payStubDetailsIncomeTaxes}</p>
          <p>payStubDetailsFEHBCost = {payStubDetailsFEHBCost}</p>
          <p>
            payStubDetailsFEGLIBasicLifeCost ={' '}
            {payStubDetailsFEGLIBasicLifeCost}
          </p>
          <p>
            payStubDetailsFEGLIOptionBMultiples ={' '}
            {payStubDetailsFEGLIOptionBMultiples}
          </p>
          <p>
            payStubDetailsFEGLIOptionBCost = {payStubDetailsFEGLIOptionBCost}
          </p>
          <p>
            payStubDetailsNetTakeHomeAnnual = {payStubDetailsNetTakeHomeAnnual}
          </p>
          <p>
            payStubDetailsNetTakeHomeMonthly ={' '}
            {payStubDetailsNetTakeHomeMonthly}
          </p>
          <p>
            payStubDetailsNetTakeHomePerPayPeriod ={' '}
            {payStubDetailsNetTakeHomePerPayPeriod}
          </p>
          <p>&nbsp;</p>
          <p>
            socialSecuritySocialSecurityFullRetirementAge ={' '}
            {socialSecuritySocialSecurityFullRetirementAge}
          </p>
          <p>
            socialSecurityEstimatedGrossMonthlySocialSecurityatAge62Amount ={' '}
            {socialSecurityEstimatedGrossMonthlySocialSecurityatAge62Amount}
          </p>
          <p>
            socialSecurityAgeBeginCollectingSocialSecurity ={' '}
            {socialSecurityAgeBeginCollectingSocialSecurity}
          </p>
          <p>
            socialSecurityEstimatedGrossMonthlySocialSecurityAmount ={' '}
            {socialSecurityEstimatedGrossMonthlySocialSecurityAmount}
          </p>
          <p>socialSecurityMonthsforR1m1 = {socialSecurityMonthsforR1m1}</p>
          <p>socialSecurityMonthsforR2m2 = {socialSecurityMonthsforR2m2}</p>
          <p>socialSecurityMonthsforGm3 = {socialSecurityMonthsforGm3}</p>
          <p>
            socialSecurityEstimatedSocialSecurityatFRA ={' '}
            {socialSecurityEstimatedSocialSecurityatFRA}
          </p>
          <p>
            socialSecuritySocialSecurityBenefit ={' '}
            {socialSecuritySocialSecurityBenefit}
          </p>
          <p>&nbsp;</p>
          <p>atRetirementGrossPension = {atRetirementGrossPension}</p>
          <p>atRetirementFERSSupplement = {atRetirementFERSSupplement}</p>
          <p>atRetirementSocialSecurity = {atRetirementSocialSecurity}</p>
          <p>atRetirementGrossIncome = {atRetirementGrossIncome}</p>
          <p>atRetirementFEHB = {atRetirementFEHB}</p>
          <p>atRetirementBasicLife = {atRetirementBasicLife}</p>
          <p>atRetirementIncomeTaxes = {atRetirementIncomeTaxes}</p>
          <p>atRetirementNetTakeHomeAnnual = {atRetirementNetTakeHomeAnnual}</p>
          <p>
            atRetirementNetTakeHomeMonthly = {atRetirementNetTakeHomeMonthly}
          </p>
          <p>&nbsp;</p>
          <p>
            tspBalanceTraditionalTSPBalance = {tspBalanceTraditionalTSPBalance}
          </p>
          <p>&nbsp;</p>
          <p>
            incomesComparisonNetTakeHomeWhileWorkingAnnual ={' '}
            {incomesComparisonNetTakeHomeWhileWorkingAnnual}
          </p>
          <p>
            incomesComparisonInRetirementAnnual ={' '}
            {incomesComparisonInRetirementAnnual}
          </p>
          <p>
            incomesComparisonAnnualDifference ={' '}
            {incomesComparisonAnnualDifference}
          </p>
          <p>
            incomesComparisonNetTakeHomeWhileWorkingMonthly ={' '}
            {incomesComparisonNetTakeHomeWhileWorkingMonthly}
          </p>
          <p>
            incomesComparisonInRetirementMonthly ={' '}
            {incomesComparisonInRetirementMonthly}
          </p>
          <p>
            incomesComparisonMonthlyDIfference ={' '}
            {incomesComparisonMonthlyDIfference}
          </p>
          <p>
            incomesComparisonEffectiveHourlyWage ={' '}
            {incomesComparisonEffectiveHourlyWage}
          </p>
        </SoftBox>
      </Grid>
    </SoftBox>
  )
}
